import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { useSite, useSeo } from "@/context/SiteContext";
import { api, has } from "@/lib/api";
import { Section, PageHero, ReviewCard, Empty, CtaBanner } from "@/components/public/Shared";
import { useT } from "@/i18n";

export default function Reviews() {
  const t = useT();
  const { apartments, content } = useSite();
  const [data, setData] = useState({ items: [], stats: {} });
  const [filter, setFilter] = useState("all");
  useSeo();
  useEffect(() => { api.get("/public/reviews").then((r) => setData(r.data)); }, []);
  const items = filter === "all" ? data.items : data.items.filter((r) => r.apartment_id === filter);
  return (
    <div data-testid="reviews-page">
      <PageHero eyebrow={t("Avis voyageurs")} title={content.reviews_section?.title || t("Ils ont séjourné chez Badouille")} image={content.welcome?.image_url} testId="reviews-hero" />
      <Section className="bg-ecru">
        {has(data.stats?.average) && (
          <div className="card inline-flex items-center gap-5 px-6 py-4 mb-10" data-testid="reviews-stats">
            <span className="font-serif text-5xl text-forest">{data.stats.average}</span>
            <div><div className="flex gap-0.5">{[1, 2, 3, 4, 5].map((i) => <Star key={i} size={16} className={i <= Math.round(data.stats.average) ? "fill-gold text-gold" : "text-sand"} />)}</div><p className="text-xs text-charcoal/60 mt-1">{data.stats.count > 1 ? t("Moyenne calculée sur {n} avis publiés", { n: data.stats.count }) : t("Moyenne calculée sur {n} avis publié", { n: data.stats.count })}</p></div>
          </div>
        )}
        <div className="flex flex-wrap gap-2" role="group" aria-label={t("Filtrer par appartement")}>
          <button onClick={() => setFilter("all")} data-testid="reviews-filter-all" className={`px-4 py-2.5 rounded-full text-xs font-medium border ${filter === "all" ? "bg-forest text-ecru border-forest" : "bg-white border-sand hover:border-forest"}`}>{t("Tous")}</button>
          {apartments.map((a) => <button key={a.id} onClick={() => setFilter(a.id)} data-testid={`reviews-filter-${a.slug}`} className={`px-4 py-2.5 rounded-full text-xs font-medium border ${filter === a.id ? "bg-forest text-ecru border-forest" : "bg-white border-sand hover:border-forest"}`}>{a.name}</button>)}
        </div>
        {items.length ? <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">{items.map((r) => <ReviewCard key={r.id} r={r} apartments={apartments} />)}</div>
          : <div className="mt-10"><Empty testId="reviews-empty">{t("Aucun avis publié pour le moment. Les premiers avis de nos voyageurs apparaîtront ici.")}</Empty></div>}
      </Section>
      <CtaBanner />
    </div>
  );
}
